'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Check.es.js";
const o = a.forwardRef((c, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...c, weights: a$1 }));
o.displayName = "CheckIcon";
const n = o;
export {
  n as Check,
  o as CheckIcon
};
